import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["backdrop", "button", "sidebar"]

  toggle() {
    this.setOpen(!this.sidebarTarget.classList.contains("open"))
  }

  close() {
    this.setOpen(false)
  }

  setOpen(open) {
    this.sidebarTarget.classList.toggle("open", open)
    document.body.classList.toggle("nav-open", open)
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", open ? "true" : "false")
    }
    if (this.hasBackdropTarget) {
      this.backdropTarget.hidden = !open
    }
  }
}
